import React from 'react';
import { addingTags, removingTags, addTagsToSkus, removeTagsToSkus } from '../actions/ProductsCreators';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import TagsInput from '../components/TagsInput';
import { message } from 'antd'
import { operateTagsToSkus } from "@/services/productService"
class BuildTag extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            posting: false,
            productIds: [],
            tags: [],
            skuIds: [],
            error: null
        };
    }

    onClickRemoveProductTagsButton() {
        this.setState({ posting: true });
        const { productIds, tags } = this.state;
        this.props.removingTags(productIds, tags, (failedIds) => {
            this.setState({ posting: false });
            if (failedIds.length == 0) {
                message.success("Remove Succeed!")
            } else {
                message.error(`Remove Failed! \n\n ${failedIds}`)
            }
        });
    }

    onClickAddProductTagsButton() {
        this.setState({ posting: true });
        const { productIds, tags } = this.state;
        this.props.addingTags(productIds, tags, (failedIds) => {
            this.setState({ posting: false });
            if (failedIds.length == 0) {
                message.success("Add Succeed!")
            } else {
                message.error(`Add Failed! \n\n ${failedIds}`)
            }
        });
    }

    onProductTagsChangeInTextArea(contents) {
        this.setState({ productIds: contents });
    }

    onProductTagsInputChange(tags) {
        this.setState({ tags: tags });
    }

    onClickRemoveSkuTagsButton() {
        this.setState({ posting: true });
        const { skuIds, tags } = this.state;
        this.props.removeTagsToSkus(skuIds, tags, (success, error) => {
            this.setState({ posting: false });
            if (success) {
                message.success("移除 sku tags 成功");
            } else {
                console.error(error)
                message.error(`移除 sku tags 失败\n${error.message}`);
            }
        });
    }

    onClickAddSkuTagsButton() {
        this.setState({ posting: true });
        const { skuIds, tags } = this.state;
        this.props.addTagsToSkus(skuIds, tags, (success,error) => {
            this.setState({ posting: false });
            if (success) {
                message.success("添加成功");
            } else {
                console.error(error)
                message.error(`添加 sku tags 失败\n${error.message}`);
            }
        });
    }

    onSkuTagsInputChange(tags) {
        this.setState({ tags: tags });
    }

    onSkuIdsChangeInTextArea(contents) {
        this.setState({ skuIds: contents });
    }

    onOperateSkuTags = (params, type = '') => {
        this.setState({ posting: true });
        operateTagsToSkus(params).then(() => {
            message.success(`${type} success`);
        }).catch(() => {
            message.error(`${type} failed`);
        }).finally(() => {
            this.setState({ posting: false });
        })
    }

    onAddSkuTags = () => {
        const { skuIds, tags } = this.state;
        this.onOperateSkuTags({
            proSkuIds: skuIds, add: tags
        }, "add")
    }

    onReplaceSkuTags = () => {
        const { skuIds, tags } = this.state;
        this.onOperateSkuTags({
            proSkuIds: skuIds, replace: tags
        }, "replace")
    }

    render() {
        return (
            <div style={{
                background: '#fff',
                padding: '15px 0'
            }}>
                <div className="text-danger mt-3">{this.state.error && this.state.error.Error}</div>
                <div className='mt-3'>
                    <TagsInput title = "ProductIds:(每个id占一行，不允许空行)"
                    onTagsInputChange={ this.onProductTagsInputChange.bind(this) }  
                    onTextViewChange={ this.onProductTagsChangeInTextArea.bind(this) }
                    onClickLeftButton={ this.onClickRemoveProductTagsButton.bind(this) } 
                    onClickRightButton={ this.onClickAddProductTagsButton.bind(this) } />
                </div>
                <div className='mt-5'>
                    <TagsInput title = "SkuIds:(每个id占一行，不允许空行)"
                        onTagsInputChange={ this.onSkuTagsInputChange.bind(this) }  
                        onTextViewChange={ this.onSkuIdsChangeInTextArea.bind(this) }
                        onClickLeftButton={ this.onClickRemoveSkuTagsButton.bind(this) } 
                        onClickRightButton={this.onAddSkuTags } 
                        actions={
                            <button  
                                onClick={this.onReplaceSkuTags }
                                className="btn btn-warning"
                                type="button">    
                                Replace
                            </button>    
                        }
                    />
                </div>
            </div>
        );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ addingTags, removingTags, addTagsToSkus, removeTagsToSkus }, dispatch)
}

export default connect(null, mapDispatchToProps)(BuildTag);
